import "./NavCompStyle.css";
import { motion } from "framer-motion";
export default function NavComp({ value, index }) {
  const link = ["about", "experience", "projects", "contact"];
  return (
    <motion.div whilehover={{ scale: 1.1 }} whileap={{ scale: 0.9 }} className='navcomp-div'>
      <div className='angular-icon'>{">"}</div>
      <a href={`#${link[index]}`} className='nav-link'>
        <div className='nav-heading'>{value}</div>
      </a>
    </motion.div>
  );
}
